import * as React from "react";
import { Outlet, useParams } from "react-router-dom";

import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { normalizeLocale } from "../utils/locales";

export default function SiteLayout() {
  const params = useParams();
  const locale = normalizeLocale(params.locale);

  return (
    <>
      <Header locale={locale} />
      <main>
        <Outlet />
      </main>
      <Footer />
    </>
  );
}
